import { motion } from 'motion/react'
import { transitions } from '@/lib/motion/presets'
import type { SegmentedIndicatorProps } from './SegmentedIndicator.types'

// One layoutId per control makes Motion slide the pill between segments.
export function SegmentedIndicator({
  layoutId,
  className,
}: SegmentedIndicatorProps) {
  return (
    <motion.span
      layoutId={layoutId}
      transition={transitions.modeIndicator}
      aria-hidden="true"
      className={
        className ??
        'absolute inset-0 rounded-full bg-background shadow-sm ring-1 ring-border/70'
      }
    />
  )
}

// The option radio is sr-only, so the focus ring comes from this wrapping label.
const SEGMENTED_OPTION_BASE =
  'relative flex h-full items-center rounded-full px-3.5 font-medium whitespace-nowrap cursor-pointer transition-colors has-[:focus-visible]:ring-ring/50 has-[:focus-visible]:ring-[3px]'

export function segmentedOptionClassName(active: boolean): string {
  // Both states keep font-medium so a weight swap cannot resize the segment mid-animation.
  return active
    ? `${SEGMENTED_OPTION_BASE} text-foreground`
    : `${SEGMENTED_OPTION_BASE} text-muted-foreground hover:text-foreground`
}
